import axios from 'axios';

import { store } from '../store';
import { logout } from '../actions/authentication.actions';

let httpAxiosImpl = axios.create({
    baseURL: '/'
});

httpAxiosImpl.interceptors.response.use((response) => { return response }, (error) => {
    if (error && error.response && error.response.status === 401) {
        store.dispatch(logout());
    }
    return Promise.reject(error);
});

export function get(url) {
    return httpAxiosImpl.get(url,
        {
            withCredentials: true,
        }).then((response) => { return response }, (error) => { return Promise.reject(error) });
}

export function post(url, data) {
    return httpAxiosImpl.post(url, data);
}

export function postWithConfig(url, data, config) {
    setHeaders("", "", "");
    return httpAxiosImpl.post(url, data, config);
}

export function put(url, data) {
    return httpAxiosImpl.put(url, data);
}

//delete seems to be a keyword, cannot use it as function name
export function remove(url) {
    return httpAxiosImpl.delete(url);
}

export function setHeaders(token, guardpostId, userId) {

    httpAxiosImpl.defaults.headers.common['Acces-Control-Allow-Origin'] = "*";
}
